import React, { useState } from 'react';
import { ReactComponent as FilterIcon } from '../svg/filter.svg';
import { ReactComponent as SortIcon1 } from '../svg/sort-1.svg';
import { ReactComponent as SortIcon2 } from '../svg/sort-2.svg';
import FilterModal from './FilterModal'; // 导入FilterModal组件
import '../css/FilterSortBar.css'; // 引入样式文件

const FilterSortBar = ({ onSortChange, onOptionChange }) => {
    const [sortAsc, setSortAsc] = useState(true); // 初始排序方式为正序
    const [selectedOption, setSelectedOption] = useState('signal_strength'); // 默认选中的排序选项为信号强度
    const [showFilterModal, setShowFilterModal] = useState(false); // 控制FilterModal的显示与隐藏

    const handleSortClick = () => {
        const newSortAsc = !sortAsc;
        setSortAsc(newSortAsc); // 切换排序方式
        onSortChange(selectedOption, newSortAsc); // 调用父组件传入的排序回调函数
    };

    const handleOptionChange = (event) => {
        const newOption = event.target.value;
        setSelectedOption(newOption); // 更新选中的排序选项
        onOptionChange(newOption); // 调用父组件传入的选项变化回调函数
        onSortChange(newOption, sortAsc); // 调用父组件传入的排序回调函数
    };

    const handleFilterIconClick = () => {
        setShowFilterModal(true); // 点击FilterIcon时显示FilterModal
    };

    const handleModalClose = () => {
        setShowFilterModal(false); // 关闭FilterModal
    };

    return (
        <div className="filter-sort-bar">
            <FilterIcon className="filter-icon" onClick={handleFilterIconClick} />
            <div className="sort-icon-container" onClick={handleSortClick}>
                {sortAsc ? <SortIcon1 className="sort-icon" /> : <SortIcon2 className="sort-icon" />}
            </div>
            <select value={selectedOption} onChange={handleOptionChange} className="filter-dropdown">
                <option value="signal_strength">信号</option>
                <option value="SNR">SNR</option>
                <option value="bssid-name">BSSID</option>
                <option value="SSID">SSID</option>
                <option value="Channel">信道</option>
                <option value="Channel-width">信道频宽</option>
                <option value="Client-count">客户端数量</option>
                <option value="Tx-Power">Tx Power</option>
                <option value="Basic-Rate">Basic-Rate</option>
                <option value="QBSS-Stations">QBSS站点数</option>
            
            
            </select>
            {/* {showFilterModal && <FilterModal onClose={handleModalClose} />} 根据状态决定是否显示FilterModal */}
        </div>
    );
};

export default FilterSortBar;